module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/10@1x.ef3b30e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/resources/uploads/10@1x.png
// module id = s9Uq
// module chunks = 3 4